import Component from '../../classes/Component';
import {$dom} from '../../helpers/dom';
import {$style} from '../../helpers/style';
import variables from '../../variables';
import {isElement} from '../../helpers/_utilities';

const {get} = $dom;
const introSelector = '.js-page-about-intro';

export default function introToTop() {


  return new Component({
    name: 'introToTop',
    requiredSelector: introSelector,
    onCreate() {
      this.introEl = null;
    },
    onInit() {
      this.introEl = get(introSelector);

      $style.set(this.introEl, {
        marginTop: - variables.dom.header.offsetHeight + 'px'
      })
    },
    onDestroy() {
      if (isElement(this.introEl)) $style.remove(this.introEl, 'marginTop');

      this.introEl = null;
    }
  })
}